var exports = {
  "i": "xe533113f--5e39b3--wrapper",
  "L": "xe533113f--5e39b3--overlay",
};

module.exports = exports;
